import { type ReactElement } from 'react';
import cn from 'classnames';
import { Text, VStack } from '@direct-frontend/components';
import { Drawer, DrawerHeader, type DrawerProps } from '../Drawer';
import styles from './Alert.module.css';

export type AlertProps = Omit<DrawerProps, 'children'> & {
    title?: string;
    button?: ReactElement;
    description?: string;
    errorText?: string;
};

export const Alert = (props: AlertProps) => {
    const { title, description, button, errorText, closable, ...other } = props;

    return (
        <Drawer snapPoints={[0.75]} closable={closable} isDraggable={closable} {...other}>
            <VStack
                className={cn(styles.modal, {
                    [styles.closable]: closable,
                })}
            >
                <VStack gap="8">
                    <DrawerHeader title={title} />
                    <Text className={styles.text} size="m">
                        {description}
                    </Text>
                </VStack>
                <VStack gap="4">
                    {errorText && (
                        <Text color="red" size="xs">
                            {errorText}
                        </Text>
                    )}

                    {button}
                </VStack>
            </VStack>
        </Drawer>
    );
};
